import { DATE_TIME_FORMAT, ICreatePublicReservation } from '@localina/core';
import { DateTime } from 'luxon';
import { call, put, takeLatest } from 'redux-saga/effects';
import { ActionType, getType } from 'typesafe-actions';
import { ILocalinaWidgetApi, IReservationBookingResponse } from '../../interfaces';
import { postReservationSuccessMessage } from '../../utils/ReservationTracking';
import * as actions from './reservation-actions';

function* saveReservation(api: ILocalinaWidgetApi, action: ActionType<typeof actions.saveReservationRequested>) {
    const { restaurantId, reservation, person } = action.payload;
    const request: ICreatePublicReservation = {
        participants: reservation.participants,
        reservationDateTime:
            DateTime.fromFormat(`${reservation.date} ${reservation.time}`, DATE_TIME_FORMAT, {
                zone: 'Europe/Zurich',
            }).toISO() || '',
        guestInfo: {
            firstName: person.firstName,
            lastName: person.lastName,
            phoneNumber: person.phoneNumber,
            email: person.email,
            salutation: person.salutation,
            subscribeToNewsletter: person.subscribeToNewsletter,
            company: person.company,
            allergies: person.allergies,
        },
        comment: person.comment,
        shiftId: reservation.shiftId,
        areaId: reservation.areaId,
        sendSmsReminder: person.sendSmsReminder,
        sendEmailReminder: person.sendEmailReminder,
        website: person.website,
    };

    try {
        const bookingResponse: IReservationBookingResponse = yield call(
            [api, api.saveReservation],
            restaurantId,
            request,
        );

        yield call(postReservationSuccessMessage, {
            restaurantID: restaurantId,
            participants: reservation.participants,
            reservationDate: reservation.date,
            reservationTime: reservation.time,
        });

        yield put(actions.saveReservationSucceeded(bookingResponse));
    } catch (e) {
        yield put(actions.saveReservationFailed(e));
    }
}

export default function* reservationSaga(api: ILocalinaWidgetApi) {
    yield takeLatest(getType(actions.saveReservationRequested), saveReservation, api);
}
